import {
	ExamBookingEnum,
	HealthBookingEnum,
	OdontoBookingEnum,
	TelehealthBookingEnum,
} from 'presentation/constants';
import {BookingTypeEnum} from '../../constants';

import {buildUrl} from './buildUrl';
import {paramsConfig} from './paramsConfig';
import {ServiceConfigProps} from './types';
import {BookingOriginEnum} from 'presentation/modules/booking/shared/constants/bookingOriginEnum';
import {TELEMEDICINE_INFO} from 'presentation/modules/booking/shared/constants/telemedicineInfo';

const telehealthConfig = ({
	currentSearchParams,
	setBookingData,
	phone,
	email,
}: ServiceConfigProps): string => {
	const bookingType = BookingTypeEnum.TELEHEALTH;
	const bookingOrigin = BookingOriginEnum.BOOKING_TELEHEALTH;
	const url = TelehealthBookingEnum.TELEHEALTH_BOOKING_FLOW;

	const params = paramsConfig({
		currentSearchParams,
		bookingType,
		bookingOrigin,
		setBookingData,
		phone,
		email,
		ufCode: TELEMEDICINE_INFO.ufCode,
		ufName: TELEMEDICINE_INFO.ufName,
		cityName: TELEMEDICINE_INFO.cityName,
	});
	return buildUrl({url, params});
};

const examConfig = ({currentSearchParams, setBookingData, phone, email}: ServiceConfigProps) => {
	const bookingType = BookingTypeEnum.EXAM;
	const bookingOrigin = BookingOriginEnum.BOOKING_EXAM;
	const url = ExamBookingEnum.EXAM_BOOKING_FLOW;

	const params = paramsConfig({
		currentSearchParams,
		bookingType,
		bookingOrigin,
		setBookingData,
		phone,
		email,
	});
	return buildUrl({url, params});
};

const odontoConfig = ({currentSearchParams, setBookingData, phone, email}: ServiceConfigProps) => {
	const bookingType = BookingTypeEnum.ODONTO;
	const bookingOrigin = BookingOriginEnum.BOOKING_ODONTO;
	const url = OdontoBookingEnum.ODONTO_BOOKING_FLOW;

	const params = paramsConfig({
		currentSearchParams,
		bookingType,
		bookingOrigin,
		setBookingData,
		phone,
		email,
	});
	return buildUrl({url, params});
};

const healthConfig = ({currentSearchParams, setBookingData, phone, email}: ServiceConfigProps) => {
	const bookingType = BookingTypeEnum.HEALTH;
	const bookingOrigin = BookingOriginEnum.BOOKING_HEALTH;
	const url = HealthBookingEnum.HEALTH_BOOKING_FLOW;

	const params = paramsConfig({
		currentSearchParams,
		bookingType,
		bookingOrigin,
		setBookingData,
		phone,
		email,
	});
	return buildUrl({url, params});
};

export {examConfig, healthConfig, odontoConfig, telehealthConfig};
